module.exports = __webpack_public_path__ + "static/img/logo.71bd1298.svg";